
import { Entry, ReferencedEntry } from 'contentful';
import {
  ContentType,
  HasTitle,
  InternalLink,
  LinkSet,
  Navigation,
  NavigationItem,
  NavigationType,
  Page,
  Set,
  VerticalMarket,
} from 'src/api/contentful/contentTypes.cloverdotcom';
import { Entries, Field } from 'src/api/contentful/utilTypes';
import { getContentType } from 'src/utils/CloverdotcomEntryUtil';
import { getField, isEntry } from 'src/utils/EntryUtil';

export type VerticalLinkSet = LinkSet & Field<{
  verticalMarket: ReferencedEntry<VerticalMarket>;
}>;

export type ProcessedNavigation = Set<NavigationItem | VerticalLinkSet> & HasTitle & Field<{
  type: NavigationType;
}>;

export function processNavigation(entry?: ReferencedEntry<Navigation>): Entry<ProcessedNavigation> | undefined {
  if (!isEntry(entry)) return;

  return {
    ...entry,
    fields: {
      ...entry.fields,
      items: processItems(entry.fields.items || []),
    },
  };
}

function processItems(entries: Entries<NavigationItem>) : Entries<NavigationItem | VerticalLinkSet> {
  const ret: Array<ReferencedEntry<NavigationItem & VerticalLinkSet>> = [];

  entries.forEach(item => {
    if (!isEntry(item)) return;

    switch (getContentType(item)) {
      case ContentType.LINK_SET:
        ret.push(processLinkSet(item));
        break;
      default:
        ret.push(item);
        break;
    }
  });

  return ret;
}

function processLinkSet(entry: ReferencedEntry<LinkSet>): ReferencedEntry<VerticalLinkSet> {
  const items = getField(entry, 'items', []);
  let verticalMarket: ReferencedEntry<VerticalMarket> | undefined;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    switch (getContentType(item)) {
      case ContentType.BASIC_PAGE:
        verticalMarket = getField(item as ReferencedEntry<Page>, 'verticalMarket');
        break;
      case ContentType.INTERNAL_LINK:
        verticalMarket = getField(getField(item as ReferencedEntry<InternalLink>, 'page') as ReferencedEntry<Page>, 'verticalMarket');
        break;
    }
    if (verticalMarket !== undefined) break;
  }

  return {
    ...entry,
    fields: {
      ...entry.fields,
      verticalMarket,
    },
  };
}
